@if (task() && response) {
  <div class="responseDetail">
    <h3 class="responseHeader">{{ task().name }}</h3>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Entity ID:</label>
      </span>
      <span class="inputField">
        <label>{{ task().entityId }};{{ task().entityRevision }}</label>
      </span>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <label>Cancel Reason</label>
      </span>
      <span class="inputField">
        <select name="delegateInput" id="delegateInput" class="inputField" [(ngModel)]="response.additionalData">
          @for (reason of cancelReasons(); track reason) {
            <option [value]="reason.code">{{ reason.description }}</option>
          }
        </select>
      </span>
    </div>
    <div class="inputRow">
      <span class="inputLabel">
        <input class="checkboxInput" type="checkbox" id="generateRevisionInput" name="generateRevisionInput" [(ngModel)]="response.generateRevision"/>
      </span>
      <span>
        <label for="generateRevisionInput">Generate Revision</label>
      </span>
    </div>
    <div class="toolbar">
      <span class="spacer"></span>
      <span>
        <button class="primary-button" matButton="elevated" [disabled]="!response || !response.additionalData || isBusy()" (click)="saveResponse()">
          <span>
            <mat-icon class="size-16">done</mat-icon>
            <label>Complete Task</label>
          </span>
        </button>
      </span>
    </div>
  </div>
}
@if (errorMessage()) {
  <div class="errorMessage">
    <pre>{{ errorMessage() }}</pre>
  </div>
}
@if (isBusy()) {
  <div class="busyIndicator">
    <div class="busyContents">
      <mat-progress-spinner diameter="48" mode="indeterminate"></mat-progress-spinner>
      <label class="busyLabel">Please Wait...</label>
    </div>
  </div>
}

